var $422a7013ab2cb36d$exports = {};
$422a7013ab2cb36d$exports = {
    "(optional)": `\u{FF08}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}\u{FF09}`,
    "(required)": `\u{FF08}\u{5FC5}\u{9808}\u{FF09}`
};


export {$422a7013ab2cb36d$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
